import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Bucket as BucketType } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces';
import Bucket from './Bucket';
import Box from '@material-ui/core/Box';
import useStyles from './styles';
import { WorkflowPlanStore } from 'stores/workflowStores/newWorkflowPlanStore/workflowPlanStore';
import { Currency } from 'enums';

interface Props {
  buckets: BucketType[] | undefined;
  originalBuckets?: BucketType[];
  onBucketActivate: (bucketType: string) => void;
  accountId: string;
  handleRiskChange: Function;
  viewDetail?: Function;
  activatedBucketType: string | null;
  currency: Currency;
  readOnly?: boolean;
  showAdditionalInfo?: boolean;
  mobile?: boolean;
  tablet?: boolean;
  store?: WorkflowPlanStore;
  currencyHedgingEnabled: boolean;
  rebalancingEnabled: boolean;
  rebalancingTimeTestDisabled?: boolean;
  userMode?: boolean;
  detailMode?: boolean;
  overview?: boolean;
}

/**
 * Section with activeBuckets as changeable 'tabs'
 */
const BucketTabSection: React.FC<Props> = ({
  store,
  buckets,
  originalBuckets,
  children,
  onBucketActivate,
  activatedBucketType,
  accountId,
  handleRiskChange,
  currency,
  readOnly,
  showAdditionalInfo,
  viewDetail,
  mobile,
  tablet,
  currencyHedgingEnabled,
  rebalancingEnabled,
  rebalancingTimeTestDisabled,
  userMode,
  detailMode,
  overview,
}) => {
  const classes = useStyles({});

  const [bucketsStyle, setBucketsStyle] = useState('');
  const showDetail = (bucket?: string) => {
    setBucketsStyle(bucket || '');
    bucket && onBucketActivate(bucket);
    viewDetail && viewDetail(!!bucket);
  };

  const anyRiskChange =
    buckets &&
    buckets.some(
      (bucket) =>
        bucket.active &&
        ((bucket.originalRiskProfile !== undefined && bucket.originalRiskProfile !== bucket.riskProfile) ||
          (originalBuckets &&
            originalBuckets.find((oB) => oB.type === bucket.type)?.riskProfile !== bucket.riskProfile)),
    );

  return (
    <Grid container className={`${classes.bucketsSwitch} ${bucketsStyle} ${classes.wrapper}`} spacing={0}>
      {buckets ? (
        <>
          {buckets.map((bucket: BucketType) => (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={4}
              xl={4}
              key={bucket.type}
              id={`${bucket.type}-bucket`}
              onClick={() => {
                onBucketActivate(bucket.type);
                showDetail && showDetail(bucket.type);
              }}
              className={`${classes.bucketWrapper} ${bucket.type}`}
            >
              <Bucket
                {...bucket}
                activated={!!(activatedBucketType && activatedBucketType === bucket.type)}
                accountId={accountId}
                onRiskChange={handleRiskChange}
                currency={currency}
                readOnly={readOnly}
                showAdditionalInfo={showAdditionalInfo}
                showDetail={showDetail}
                mobile={mobile}
                tablet={tablet}
                store={store}
                currencyHedgingEnabled={currencyHedgingEnabled}
                rebalancingEnabled={rebalancingEnabled}
                rebalancingTimeTestDisabled={rebalancingTimeTestDisabled}
                userMode={userMode}
                detailMode={detailMode}
                profileLockActive={!!store?.data?.profileLockActive && bucket.type === 'LONG_TERM'}
                profileLockDuration={store?.data?.profileLockDuration}
                anyRiskChange={anyRiskChange}
                overview={overview}
                originalBucket={originalBuckets ? originalBuckets.find((oB) => oB.type === bucket.type) : undefined}
              />
            </Grid>
          ))}
        </>
      ) : (
        <Box mt={4} />
      )}
      {viewDetail && (
        <Grid item xs={12} className={`${classes.tabsSection} BUCKET_DETAIL`}>
          {children}
        </Grid>
      )}
      {overview && (
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      )}
    </Grid>
  );
};

export default BucketTabSection;
